
/*
    Properties for related accessories:
    turn_on:    Turn ON when this accessory turns on
    turn_off:   Turn OFF when this accessory turns off
    unique:     Turn OFF when this accessory turns on
*/

const accessories =
{
    // --- Fitness ----------------------------------------------------------------------
    // Treadmill
    'treadmill': {
        title: 'Underwater Treadmill',
        price: 9999,
        showInScene: true,
        description: 'Available in all Modular pools and E-Series models, our exclusive hydraulically-powered Underwater Treadmill turns running and walking into low-impact activities that are easy on your back and joints. A must for your fitness, health, and weight-loss goals, our Underwater Treadmill gives you total-body resistance with every step thanks to the aquatic environment; turn on the Endless Pools current for a more vigorous core workout.',
        restriction: 'E500, E550, E700, and E2000 in 58" depth only'
    },
    // Underwater Mirror aka the floor mirror
    'mirror': {
        title: 'Underwater Mirror',
        price: 599,
        showInScene: true,
        description: 'See yourself swim in place and refine your form using the optional 24” x 51” stainless steel mirror. Placed on the floor in front of your adjustable current, its weight distribution and gentle suction ensure that it stays in place. Not recommended for swim spas with an Underwater Treadmill installed; for Modular pools, the mirror can rest on top of the Treadmill.',
        restriction: 'Not recommended for models with Underwater Treadmill installed.'
    },
    // Swim mirror (the one that's tilted)
    'swim-mirror': {
        title: 'Swim Mirror',
        price: 295,
        showInScene: true,
        no_video: true,
        description: 'See yourself swim in place and refine your form using the optional 24” x 51” stainless steel mirror. Placed on the floor in front of your adjustable current, its weight distribution and gentle suction ensure that it stays in place. Not recommended for swim spas with an Underwater Treadmill installed; for Modular pools, the mirror can rest on top of the Treadmill.',
        restriction: 'Not recommended for models with Underwater Treadmill installed.'
    },
    // Pace Display
    'pace': {
        title: 'Pace Display',
        price: 299,
        description: 'Allows for easy reading of the swim current pace and/or treadmill speed during exercise. You can easily toggle from meters to yards or view the pace as a percentage of the total output. It’s recommended that users have individual Pace Displays for their swim current and treadmill for simultaneously use.',
        restriction: 'E500, E550, E700, and E2000 only.'
    },
    // Aqua Bike
    'aqua-bike': {
        title: 'Aqua Bike',
        price: 1499,
        showInScene: true,
        description: 'Get an effective workout without strain on your muscles and joints with this lightweight, yet stable, stationary Aqua Bike. It’s ideal for low to medium-intensity workouts and can be positioned in front of the swim current for a more challenging ride.'
    },
    // // Row Bar Kit [discontinued]
    // 'row-bar': {
    //     title: 'Row Bar Kit',
    //     price: 499,
    //     no_video: true,
    //     description: 'Bring fun and effective rowing workouts to your pool! Rowing burns calories, boosts heart health, and works your whole upper body. Our Rowing Kit features adjustable tension and easy attach/detach anchors; it fits pools up to a maximum width of 9\'.',
    // },
    // Swim Tether
    'tether': {
        title: 'Swim Tether',
        price: 275,
        showInScene: false,
        description: 'It’s a must for beginner swimmers or for anyone looking to improve his or her swimming form, by adding further resistance.',
    },
    // Swim Tether (Streamline-specific version)
    'tether-streamline': {
        title: 'Swim Tether Kit',
        price: 299,
        description: '',
    },
    // Resistance Bands
    'resistance-bands': {
        title: 'Resistance Bands',
        price: 199,
        description: 'Add more resistance and strength training options to your aquatic workout with Resistance Bands. Simply attach the bands to the built-in anchor points on your Endless Pools® Fitness System for a variety of strength-building exercises. Set includes 3 pairs of color-coded resistance bands (10, 15 and 20 lbs.), with comfort-grip handles. Suitable for all levels.'
    },
    // --- Digital ----------------------------------------------------------------------
    // Bluetooth Sound System
    'bluetooth-sound-system': {
        title: 'Bluetooth®-Enabled Sound System',
        price: 1099,
        showInScene: true,
        description: 'Simply pair any Bluetooth®-enabled device through the control panel to listen to your favorite music, anytime. With an integrated 8-speaker system, you can set the mood; whether it\'s for exercise or backyard enjoyment.'
    },
    // Fit at Home Mobile + Wifi
    'fit-at-home': {
        title: 'Endless Pools Fit@Home® App & Wifi Kit',
        price: 399,
        description: 'The App allows you to control your current, underwater treadmill, or both using any smart device. Easily set the pace and duration with advanced options for creating effective interval workouts! The optional Wifi Kit must be factory-installed for app compatibility.'
    },
    // Gecko Mobile + Wifi
    'gecko': {
        title: 'Gecko® In.Touch Mobile & Wifi Kit',
        price: 299,
        description: 'The optional plug-and-play Gecko® In.Touch WiFi and Mobile App provides full control of your pool or swim spa’s temperature, lights, and jets from any WiFi-enabled tablet or mobile device.'
    },
    // Remote Pool Monitoring (Gecko, but for Modular pools)
    'remote-pool-monitoring': {
        title: 'Remote Pool Monitoring System',
        price: 299,
        description: 'The optional plug-and-play Gecko® In.Touch WiFi and Mobile App provides full control of your pool or swim spa’s temperature, lights, and jets from any WiFi-enabled tablet or mobile device.'
    },
    // --- Accessibility ----------------------------------------------------------------------
    // Corner step
    'corner-step': {
        title: 'Corner Step',
        price: 345,
        no_video: true,
        showInScene: true,
        description: 'The optional Corner Step(s) adds security to your entry and exit. The Corner Step provides an intermediate step between your pool\'s perimeter bench and the coping. For exceptional traction and comfort, each step features cushioned, high-grip SwimDek strips. Your dedicated Product Specialist can offer experienced consultation for how to make your pool easily accessible for all users.'
    },
    // Interior Entry Steps
    'interior-entry-steps': {
        title: 'Interior Entry Steps',
        price: 525,
        no_video: true,
        showInScene: false, // Removed on client request
        description: 'The Interior Entry Stairs add stability when entering and exiting our pools. Each step is coated in our cushioned, high-traction SwimDek strips. We also offer a 5-tier model and optional Bench Risers to suit every pool depth. Your Product Specialist can share invaluable tips on the best configuration for your needs.',
    },
    // 2-Tier Step
    '2-tier-step': {
        title: '2-Tier Step',
        price: 125,
        no_video: true, 
        description: 'The exterior 2-tier Stairs have 7.5" risers (15" total height) and are capable of supporting up to 300 lbs. They assemble easily for sturdy, long-lasting utility.'
    },
        // 3-Tier Step
    '3-tier-step': {
        title: '3-Tier Step',
        price: 350,
        no_video: true, 
        description: 'Our exterior 3-tier Stairs offer integrated handrails to ease entry and exit. With a 400-lbs. capacity, the stairs are durable and non-slip. Each tread is 12" x 36". The height of the stairs is 24", or 58" including the handrails.'
    },
        // 4-Tier Step
    '4-tier-step': {
        title: '4-Tier Step',
        price: 799,
        no_video: true, 
        description: 'These lightweight steps allow for easy entry into any pool or swim spa. The dual position handrail and sturdy construction make this an option you won’t want to pass up. Not available from all retailers.'
    },
        // Heavy Duty 4-Tier Step
    'heavy-4-tier-step': {
        title: 'Heavy-Duty 4-Tier Step',
        price: 995,
        no_video: true, 
        description: 'For additional durability with a 700-lb. capacity that\'s ideal for high-traffic pools. With aluminum construction, deeper slip-resistant treads, 7.5" inch risers, and a 24" x 34.5" top landing, you get added security with every step. The Support Rail repositions to the left or right.'
    },
    // Signature Steps
    'signature-steps': {
        title: '4-Tier Step',
        price: 799,
        description: 'These lightweight steps allow for easy entry into any pool or swim spa. The dual position handrail and sturdy construction make this an option you won’t want to pass up. Not available from all retailers.'
    },
    // --- Cover ----------------------------------------------------------------------
    // Watkins Cover Set
    'watkins-cover-set': {
        title: 'Watkins Cover Set',
        price: 0,
        turn_off: ['watkins-lifter', 'easy-slider', 'covercradle-lifter'],
        special_price: [
            { model: 'r200',price: 999 },
            { model: 'r220',price: 0 },
            { model: 'r500',price: 1099 },
            { model: 'x200',price: 999 },
            { model: 'x500',price: 1099 },
            { model: 'x2000',price: 1499 },
            { model: 'e500',price: 1099 },
            { model: 'e550',price: 1199 },
            { model: 'e700',price: 1199 },
            { model: 'e2000',price: 1499 },
        ],
        description: 'The Watkins cover set helps maintain heat and reduce evaporation. It can be used on its own or with the lifter system.',
        hiddenPrice: true
    },
    // Easy Slider Cover
    'easy-slider': {
        title: 'Easy Slider Cover Mount',
        price: 329,
        unique: ['watkins-lifter', 'covercradle-lifter'], turn_on: ['watkins-cover-set'],
        description: 'The Easy Slider gives you another method of removing Bi-fold covers. By simply attaching the “arms” to the cabinet corners, the Easy Slider eliminates the need for traditional lifters and allows customers to remove the covers without needing to lift the weight of the cover.  As an added bonus, when covers are in the open position, they do not obstruct your view. Pricing for this item may vary by retailer.',
        hiddenPrice: true
    },
    // CoverCradle Lifter
    'covercradle-lifter': {
        title: 'CoverCradle® Lifter',
        price: 609,
        unique: ['watkins-lifter', 'easy-slider'], turn_on: ['watkins-cover-set'],
        description: 'This cover lifter’s unique design uses a hydraulic hinge to simplify opening and closing the Fitness System’s covers, in an ultra-smooth gliding action. For those looking for an easy lift assist and have the extra space, the CoverCradle is an excellent option. Item available from select retailers only.',
    },
    // Watkins Lifter System
    'watkins-lifter': {
        title: 'Watkins Lifter System',
        price: 699,
        unique: ['covercradle-lifter', 'easy-slider'], turn_on: ['watkins-cover-set'],
        description: 'The Watkins Lifter System enables you to position the Watkins covers vertically. Includes two lifters and spacer kit. Pricing for this item may vary by retailer.',
        hiddenPrice: true
    },
    // Security Cover
    'manual-security-cover': {
        title: 'Manual Security Cover',
        price: 1995,
        description: 'The security cover helps keep kids and pets out of the pool while controlling humidity and retaining heat. It is easily rolled away when the pool is in use. The cover features a locking mechanism and meets stringent ASTM F1346 safety standards.'
    },
    // Automatic Security Cover
    'automatic-security-cover': {
        title: 'Automatic Security Cover',
        price: 7495,
        description: 'All the security of our Manual Cover, plus the ease of turn-key operation. As a bonus, this cover installs below the pool deck for a cleaner, more polished finish. Like our Manual Cover, the Automatic Cover meets stringent ASTM F1346 safety standards.'
    },
    // --- Spa ----------------------------------------------------------------------
    // CoolZone Cooling
    'coolzone': {
        title: 'CoolZone® Cooling System',
        price: 4499,
        description: 'Ideal for extreme climate areas and year-round use, CoolZone works with the swim spa components to effectively cool or maintain the water temperature. It makes it convenient and efficient to change and retain your ideal water temperature no matter what month it is. Item available from select retailers only.'
    },
    // SwimDek Surface
    'swimdek': {
        title: 'Endless Pools Surface Kits',
        price: 0,
        showInScene: true,
        special_price: [
            { model: 'e500',price: 1798 },
            { model: 'e550',price: 1598 },
            { model: 'e700',price: 1998 },
            { model: 'e2000',price: 2197 },
            { model: 'r200',price: 998 },
            { model: 'r220',price: 0 },
            { model: 'r500',price: 1198 },
            { model: 'x200',price: 1398 },
            { model: 'x500',price: 1598 },
            { model: 'x2000',price: 2197 },
        ],
        description: 'SwimDek® Surface Kits are an excellent option to have for exercise and play. Its nonabsorbent material provides an exceptional traction surface and added comfort. SwimDek is proven to withstand outdoor aquatic environments and remain beautiful and functional over time. Floor and Step Kits are sold separately.',
        hiddenPrice: true
    },
    // LED Exterior Lighting
    'led-lighting': {
        title: 'LED Exterior Lighting',
        price: 899,
        showInScene: true,
        special_price: [{ model: 'x2000', price: 999 }],
        notInGround: true,
        description: 'Add ample brilliance and dramatic impact to any SwimCross® Exercise System or RecSport® Recreation System by installing optional Exterior LED Lighting. Each kit comes equipped with four LED light bars, that fit seamlessly into the corner cap spacers. The lights can be powered on and off from the control panel, making them feel like a standard feature.',
        disclaimer: {
            x200:  'Available in 4PC and 8PC kits. Pricing may vary based on configuration chosen.',
            x500:  'Available in 4PC and 8PC kits. Pricing may vary based on configuration chosen.',
            x2000: 'Available in 4PC and 8PC kits. Pricing may vary based on configuration chosen.',
            r200:  'Available in 4PC and 8PC kits. Pricing may vary based on configuration chosen.',
            r500:  'Available in 4PC and 8PC kits. Pricing may vary based on configuration chosen.',
        },
    },
    // --- Pool ----------------------------------------------------------------------
    // Four Underwater Lights
    'underwater-lights': {
        title: 'Underwater Lights',
        price: 599,
        no_video: true, 
        showInScene: false, // Removed on client request
        description: 'Transform your pool into a beautifully lit waterscape. Our low-energy LED lights are most easily installed with your initial pool setup, as they are difficult to retrofit. A 4-light option is also available.',
    },
    // Hydrotherapy Jets
    'hydrotherapy-jets': {
        title: 'Hydrotherapy Jets',
        price: 1495,
        no_video: true, 
        description: 'Supplement the benefits of your pool with 4 concentrated jets for therapy and relaxation. Jets are most easily installed with your initial pool setup, as they are difficult to retrofit.'
    },
    // --- Uncategorized ----------------------------------------------------------------------
    // Exercise Kit
    'exercise-kit': {
        title: 'Exercise Kit',
        price: 299,
        no_video: false, 
        description: 'With the Exercise Kit, you can easily target different muscle groups with several equipment options, countless exercises and the Endless Pools® current, which varies intensity and resistance during the workout. The Exercise Kit consists of the following: 2-10 lb. 15 lb., and 20 lb. bands, 2 handles, 1 row bar, 1 rope and easily connects to the swim spa anchors.',
        hiddenPrice: true
    },
    // newly added 2025
    'led-bench-lights': {
        title: 'Bench Lights',
        price: 0,
        no_video: true, 
        description: 'This is placeholder text. This is placeholder text. This is placeholder text. This is placeholder text. This is placeholder text. This is placeholder text. This is placeholder text. This is placeholder text. This is placeholder text. ',
        hiddenPrice: true
    },
    'two-underwater-lights': {
        title: 'Two Underwater Lights',
        price: 0,
        no_video: true, 
        description: 'This is placeholder text. This is placeholder text. This is placeholder text. This is placeholder text. This is placeholder text. This is placeholder text. This is placeholder text. This is placeholder text. This is placeholder text. ',
        hiddenPrice: true
    },
};

export default accessories;
